export default {
  active: 'ngtorch override active: {ref} ({sha})',
  activeBranch: 'ngtorch override active: latest commit on {ref}',
  reinstalling: '· reinstalling package metadata',
  manage: 'Manage',
  disable: 'Disable'
}
